import { ProspectStatus } from '../../../../common/enums/ProspectStatus';

export const defaultLabels = {
  fullName: 'Full name',
  email: 'Email',
  phoneNumber: 'Phone number',
  professionalProfile: 'Professional Profile',
  currentEmployer: 'Current or recent employer',
  currentRole: 'Current or recent role',
  sourceCandidate: 'Source candidate',
  optInDate: 'Opt-in date'
};

export const statusOptions = [{
  value: ProspectStatus.Active,
  label: { id: 'active', defaultMessage: 'Active' }
}, {
  value: ProspectStatus.Archived,
  label: { id: 'archived', defaultMessage: 'Archived' }
}];
